import React, { useState } from 'react';
import { Container, TextField, Button, Typography, Box, InputAdornment, IconButton } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { registerUser } from './auth.service';
import { Background, RegisterForm } from '../../common/Flex/Flex';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
// import { showErrorToast, showSuccessToast } from '../../common/util/util';

// Validation Schema
const validationSchema = yup.object({
    name: yup.string().required('Name is required'),
    email: yup
        .string()
        .email('Enter a valid email')
        .required('Email is required'),
    password: yup
        .string()
        .min(6, 'Password should be at least 6 characters long')
        .required('Password is required'),
});

const Register = () => {
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const handleTogglePassword = () => {
        setShowPassword((prev) => !prev);
    };
    const formik = useFormik({
        initialValues: {
            name: '',
            email: '',
            password: '',
            number: '',
            role: 'admin',
            status: 'active'
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            registerUser(values).then((res: any) => {
                // showSuccessToast(res.message);
                navigate('/auth/login')
            }).catch((err) => console.error(err));
        },
    });

    return (
        <Background>
            <Container maxWidth="md">
                {/* <RegisterForm elevation={3}> */}

                <Box sx={{ mt: 5 }}>
                    <Typography variant="h4" sx={{ textAlign: 'center', fontWeight: '600' }} gutterBottom color='white'>
                        Register
                    </Typography>
                    <form onSubmit={formik.handleSubmit}>
                        <RegisterForm elevation={3}>
                            <TextField
                                fullWidth
                                id="name"
                                name="name"
                                placeholder="Name"
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                error={formik.touched.name && Boolean(formik.errors.name)}
                                helperText={formik.touched.name && formik.errors.name}
                            // sx={{ mb: 2 }}
                            />
                        </RegisterForm>
                        <RegisterForm elevation={3}>
                            <TextField
                                fullWidth
                                id="email"
                                name="email"
                                placeholder="Email"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && formik.errors.email}
                            // sx={{ mb: 2 }}
                            />
                        </RegisterForm>
                        <RegisterForm elevation={3}>
                            <TextField
                                fullWidth
                                id="number"
                                name="number"
                                placeholder="Mobile Number"
                                value={formik.values.number}
                                onChange={formik.handleChange}
                            // sx={{ mb: 2 }}
                            />
                        </RegisterForm>
                        <RegisterForm elevation={3}>
                            <TextField
                                placeholder="Password"
                                // sx={{ mb: 2 }}
                                variant="outlined"
                                name='password'
                                type={showPassword ? "text" : "password"}
                                fullWidth
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                error={formik.touched.password && Boolean(formik.errors.password)}
                                helperText={formik.touched.password && formik.errors.password}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleTogglePassword} edge="end">
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </RegisterForm>
                        <RegisterForm elevation={3}>
                            <Button color="success" sx={{
                                background: 'linear-gradient(to right, #1e6283, #10374A)',
                                color: 'white',
                                '&:hover': {
                                    background: 'linear-gradient(to right, #10374A, #1e6283)',
                                }, fontWeight: '500'
                            }} variant="contained" size='large' fullWidth type="submit">
                                Register
                            </Button>
                        </RegisterForm>
                    </form>
                    <Typography margin={2} textAlign={'center'}>
                        Already have an account? <Box component={Link} sx={{ fontWeight: '600', color: 'white', textDecoration: 'none' }} to={'/auth/login'}>Login</Box>
                    </Typography>
                </Box>
                {/* </RegisterForm> */}
            </Container>
            <ToastContainer position="top-right" autoClose={3000} />
        </Background>
    );
};

export default Register;
